import styled from 'styled-components'
import { colors } from '../../theme'

// PD-0007 Fase 5. Compartilhado entre a lista e o detalhe (Detalhe/ importa daqui), no mesmo
// arranjo do PD-0003: duas telas do mesmo modulo nao devem divergir de aparencia.

export const Container = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  max-width: 100%;
`

export const FilterBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 16px;
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  /* Filho DIRETO de proposito: este rotulo e o <span> do proprio campo.
     Um 'span' solto tambem casaria com o <span> interno que o Select do
     Ant Design usa para exibir o valor escolhido — e o valor sairia com a
     cor do rotulo, mais apagada que o resto do texto. */

  > span {
    font-size: 12px;
    color: ${colors.grey500};
  }
`

export const HeaderLinha = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`

export const Carimbo = styled.span`
  font-size: 12px;
  color: ${colors.grey500};
`

/**
 * Aviso de nao-causalidade: fica no cabecalho, sempre visivel, nunca atras de um tooltip.
 * A especificacao exige a frase fixa na tela e no arquivo exportado.
 */
export const AvisoCausalidade = styled.p`
  margin: 0;
  padding: 10px 14px;
  border-left: 3px solid ${colors.secondary};
  background: ${colors.azulOpaco};
  border-radius: 4px;
  font-size: 12px;
  color: ${colors.primaryText};
`

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(210px, 1fr));
  gap: 12px;
`

export const MetricCard = styled.div`
  border: 1px solid ${colors.azulOpaco};
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const MetricTitle = styled.span`
  font-size: 12px;
  color: ${colors.grey500};
`

export const MetricValue = styled.span`
  font-size: 22px;
  font-weight: 600;
  color: ${colors.primaryText};
`

/** Valor suprimido: mesmo tamanho, cor apagada. Um traco grande em verde leria como numero. */
export const MetricValueSemDado = styled.span`
  font-size: 22px;
  font-weight: 600;
  color: ${colors.grey500};
`

export const MetricHint = styled.span`
  font-size: 11px;
  color: ${colors.grey500};
`

/**
 * Numerador e denominador absolutos embaixo de todo percentual.
 * E isto que torna o numero reproduzivel no ERP do cliente sem lista nominal: "quantos clientes
 * compraram em agosto?" e uma consulta de uma linha la.
 */
export const MetricFracao = styled.span`
  font-size: 12px;
  color: ${colors.grey600};
  font-variant-numeric: tabular-nums;
`

export const SectionTitle = styled.h3`
  margin: 8px 0 0;
  font-size: 16px;
  color: ${colors.primaryText};
`

export const ChartWrapper = styled.div`
  border: 1px solid ${colors.azulOpaco};
  border-radius: 8px;
  padding: 12px;
`

export const PainelConvencoes = styled.div`
  border: 1px solid ${colors.azulOpaco};
  border-radius: 8px;
  padding: 4px 16px 12px;

  dl {
    margin: 0;
    display: grid;
    grid-template-columns: minmax(160px, auto) 1fr;
    gap: 6px 16px;
    font-size: 12px;
  }

  dt {
    color: ${colors.primaryText};
    font-weight: 600;
  }

  dd {
    margin: 0;
    color: ${colors.grey600};
  }
`

export const Badge = styled.span<{ alerta?: boolean }>`
  display: inline-block;
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 11px;
  white-space: nowrap;
  color: ${props => (props.alerta ? colors.errorText : colors.grey600)};
  border: 1px solid ${props => (props.alerta ? colors.error : colors.azulOpaco)};
`

const corDelta = (positivo?: boolean, negativo?: boolean): string => {
  if (positivo) return colors.secondaryText
  if (negativo) return colors.errorText
  return colors.grey500
}

export const DeltaHint = styled.span<{
  positivo?: boolean
  negativo?: boolean
}>`
  display: block;
  font-size: 11px;
  color: ${props => corDelta(props.positivo, props.negativo)};
`

export const LinhaBotoes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
`

/**
 * Bloco de texto auxiliar. Com `erro`, vira aviso destacado.
 *
 * ⚠️ A variante existe porque falha tecnica renderizada como legenda cinza se le como fato de
 * negocio: um "Sem permissao para o acesso." aparecia igualzinho a "Nenhuma competencia congelada",
 * e o super-admin concluiria que a conta nao tem dado quando o que houve foi um 403.
 */
export const AvisoBloco = styled.p<{ erro?: boolean }>`
  margin: 0;
  font-size: 12px;
  color: ${props => (props.erro ? colors.errorText : colors.grey600)};
  ${props =>
    props.erro
      ? `padding: 10px 14px; border-left: 3px solid ${colors.error};
         background: ${colors.lightRed}; border-radius: 4px; font-weight: 600;`
      : ''}
`

/** Acoes de uma linha da tabela. `nowrap` para o par de botoes nao quebrar em duas alturas. */
export const AcoesLinha = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: nowrap;
`

/**
 * Texto do popup de confirmacao da reabertura.
 *
 * Largura fixada porque o padrao do Popconfirm e estreito para uma frase, e aqui o texto E a
 * protecao: espremido em cinco linhas, ninguem le - e a acao e irreversivel.
 */
export const TextoConfirmacao = styled.span`
  display: block;
  max-width: 340px;
  font-size: 12px;
  line-height: 1.5;
  color: ${colors.grey600};
`
